/**
 * Repeating diagonal watermark over an unlicensed drawing.
 *
 * This is a deterrent, not the protection — the drawing underneath is already
 * missing its protected data (see geometry.ts). Removing this node in devtools
 * reveals nothing extra.
 */
export function Watermark({ mark }: { mark: string }) {
  return <div className="fp-watermark" data-mark={mark.repeat(6)} aria-hidden="true" />;
}

/** Small lock/licensed pill shown on plan cards and the viewer. */
export function LockBadge({ owned }: { owned: boolean }) {
  return (
    <span className={`fp-lock-badge${owned ? " fp-lock-badge--owned" : ""}`}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {owned ? (
          <>
            <circle cx="12" cy="12" r="9" />
            <path d="m8.5 12 2.5 2.5 4.5-5" />
          </>
        ) : (
          <>
            <path d="M12 3.5 5 6v6c0 4.2 3 7.4 7 8.5 4-1.1 7-4.3 7-8.5V6Z" />
            <circle cx="12" cy="11" r="2" />
            <path d="M12 13v2.5" />
          </>
        )}
      </svg>
      {owned ? "Licensed" : "Preview"}
    </span>
  );
}
